import { call, put, select, takeLatest } from "redux-saga/effects";
import { editCompany, setLoading } from "../actions";
import { Auth } from "../utilities/auth";
import axios from "../utilities/axiosWrapper";

// Auth reducer
export const selectAuthReducer = (state: any) => state.authReducer;

/**
 * @desc Loads a company for the super admin classes tab.
 *
 * getCompany stores the business flat, but getCompanyDashboardInfo - which the
 * shared ClassEditor reads - expects it nested under `business`. Fetching here
 * and dispatching the nested shape keeps the selector resolving, so the plan
 * type and class list belong to the company being viewed.
 * @param {*} action
 * @return {*}  {Generator}
 */
export function* fetchCompanyForClassesWorker(action: any): Generator {
	yield put(setLoading({ loading: true, errorMessage: "" }));
	let selectedAuthReducer: any = yield select(selectAuthReducer);
	let apikeys: any = null;
	let jsonResponse: any = null;
	let params: any = {
		method: "get",
		path: `businesses/${action.data}?at=${selectedAuthReducer.accessToken}`,
		data: {},
	};

	try {
		apikeys = yield Auth.getAuthTokens();
		jsonResponse = yield call(axios, params, apikeys);

		if (jsonResponse?.data?.fnResult) {
			const business = JSON.parse(jsonResponse.data.fnResult);
			yield put(editCompany({ business }));
		}

		return yield put(setLoading({ loading: false }));
	} catch (ex) {
		return yield put(
			setLoading({
				loading: false,
				alertType: "error",
				errorMessage: "Could not load this company's plan details.",
			})
		);
	}
}

/**
 * @return {*}  {Generator}
 */
function* fetchCompanyForClassesWatcher(): Generator {
	yield takeLatest("FETCH_COMPANY_FOR_CLASSES", fetchCompanyForClassesWorker);
}

export { fetchCompanyForClassesWatcher };
